export const percentageOptions = [
	{ id: 0, label: '0%', value: '0' },
	{ id: 1, label: '5%', value: '5' },
	{ id: 2, label: '10%', value: '10' },
	{ id: 3, label: '15%', value: '15' },
]
